export default function LinkedInSquareIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <g clipPath="url(#linkedSquare)">
        <path
          fill="#0077B5"
          d="M27.636 0H4.364A4.364 4.364 0 000 4.364v23.272A4.364 4.364 0 004.364 32h23.272A4.364 4.364 0 0032 27.636V4.364A4.364 4.364 0 0027.636 0z"
        />
        <path
          fill="#fff"
          d="M11.527 8.727a2.727 2.727 0 11-5.455 0 2.727 2.727 0 015.455 0zm-.617 4.546v12.049a.677.677 0 01-.675.678H7.36a.675.675 0 01-.676-.676V13.273a.677.677 0 01.676-.677h2.875a.677.677 0 01.674.677zm15.024 6.273v5.832a.62.62 0 01-.622.622h-3.09a.622.622 0 01-.622-.622v-5.652c0-.844.247-3.695-2.206-3.695-1.9 0-2.287 1.95-2.363 2.827v6.52a.622.622 0 01-.613.622h-2.986a.62.62 0 01-.62-.622V13.22a.62.62 0 01.62-.622h2.986a.622.622 0 01.622.622v1.05c.705-1.057 1.75-1.874 3.982-1.874 4.941 0 4.912 4.615 4.912 7.15z"
        />
      </g>
      <defs>
        <clipPath id="linkedSquare">
          <path
            fill="#fff"
            d="M0 0h32v32H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
